import BaseModule from "./base-module";
import axios from 'axios';

class Qrcode extends BaseModule {
    // 加入购物车
    addCart(payload) {
        if(window.addCartRequestCancel) window.addCartRequestCancel();
        return this.post(`/qrcode/v1/cart`, payload, {
            cancelToken: new axios.CancelToken(function executor(c) {
                window.addCartRequestCancel = c
            })
        });
    }

    // 获取某个桌子的购物车内的内容
    loadCart(payload) {
        return this.get(`/qrcode/v1/cart/${payload.tableGuid}`, payload);
    }

    // 下单
    createOrder(payload, isBuffet) {
        return this.post(`/qrcode/v1/order`, {
            ...(payload || {}),
            buffet: isBuffet === 2 ? 1 : 0
        });
    }

    // 获取某个桌子的当前未支付的订单内容
    loadMyOrder(payload) {
        return this.get(`/qrcode/v1/myorder/${payload.tableGuid}`, payload);
    }

    getDeliveyBanner(params) {
        return this.get("/qrcode/v1/get/backgimg", {params});
    }
}

export default new Qrcode();
